import React from 'react';
import styles from './QuoteMark.module.css';

function QuoteMark({ className }) {
	return <span className={`${styles.quoteMark} ${className}`}>″</span>;
}

export default QuoteMark;
